import React from "react";
import { DisplayDiscussionForMiniScreenProvider } from "../contexts/DisplayDiscussionForMiniScreenContext";
import Navbar from "../components/Navbar";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import Meet from "../components/Meet";
import Chatbot from "../components/chat/Chatbot";

export default function MeetOptionsPage() {
  return (
    <DisplayDiscussionForMiniScreenProvider>
      <Navbar />
      <ContentFormSquelette>
        <Meet />
        <Chatbot />
      </ContentFormSquelette>
    </DisplayDiscussionForMiniScreenProvider>
  );
}
